export default __webpack_public_path__ + "static/media/plug.cd101990.svg";